// store/modules/user.js

import api from '@/helpers/api'

export default {
  namespaced: true,
  state: {
    contents: {},
  },
  mutations: {
    SET_CONTENTS: (state, contents) => {
      state.contents = contents
    },
  },
  actions: {
    getContents: async ({ commit }) => {
      try {
        const response = await api.getContents()
        commit('SET_CONTENTS', response)
      } catch (error) {
        console.log(error)
      }
    },
  },
  getters: {
    getContents: state => state.contents,
    getContentById: state => (id) => state.contents.find(content => content.id === id),
  },
}
